import type { ConversationListItem } from "api/services/messaging/schemas/messaging";

export function sortConversations(a: ConversationListItem, b: ConversationListItem) {
  const dateA = a.last_message ? new Date(a.last_message.created_at).getTime() : 0;
  const dateB = b.last_message ? new Date(b.last_message.created_at).getTime() : 0;
  return dateB - dateA;
}
